<template>
  <div>
    <el-form :inline="true" :model="searchForm" class="demo-form-inline">
      <!-- 筛选项配置化，方便统一维护 -->
      <el-select
          v-for="select in formSelects"
          :key="select.key"
          v-model="searchForm[select.model]"
          :placeholder="select.placeholder"
          :class="select.className"
          @change="handleSelectChange(select)">
        <el-option v-for="item in select.options"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
        </el-option>
      </el-select>
      <el-form-item>
        <el-input v-model="searchForm.keyword"
                  class="search-input"
                  placeholder="请输入诊所名称、医生名称或者手机号码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" class="primary-search-btn">查询
        </el-button>
      </el-form-item>
    </el-form>

    <el-card class="box-card" shadow="hover">
      <div slot="header" class="clearfix card-header">
        <i class="el-icon-card-header"></i>
        <span>数据列表一览</span>
      </div>
      <el-table :data="resultTbl" :header-cell-style="tableHeaderStyle"
                :row-class-name="tableRowClassName"
                style="width: 100%;" height="710">
        <!-- 表格列配置化，避免重复 DOM -->
        <template v-for="column in tableColumns">
          <el-table-column
              v-if="!column.isAction"
              :key="column.key + '-data'"
              v-bind="column.columnProps">
          </el-table-column>
          <el-table-column v-else :key="column.key + '-action'" :label="column.label" :width="column.width">
            <template slot-scope="scope">
              <el-button @click="open_detail(scope.row)" type="text" size="small" class="action-text-btn">
                {{ column.actionLabel }}
              </el-button>
            </template>
          </el-table-column>
        </template>
      </el-table>

      <div class="block pagination-block">
        <el-pagination v-if="total_record"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="searchForm.page_num"
                       :page-sizes="paginationConfig.pageSizes"
                       :page-size="paginationConfig.pageSize"
                       layout="sizes, prev, pager, next"
                       :total="total_record">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import {Role} from "@/role";
import { buildAppWebUrl } from '@/utils/appWebUrl';

const API_HOST = process.env.VUE_APP_API_HOST;
const JSON_HEADERS = {"content-type": "application/json"};
// 表单筛选项配置
const FORM_SELECT_CONFIGS = [
  {
    key: 'shengqu',
    model: 'shengqu',
    placeholder: '请选择省区',
    className: 'select-compact select-offset',
    optionsKey: 'options_shengqu',
    onChange: 'get_diban_zssy'
  },
  {
    key: 'diban',
    model: 'diban',
    placeholder: '请选择地办',
    className: 'select-compact select-offset',
    optionsKey: 'options_diban'
  }
];
// 表格列配置
const TABLE_COLUMNS = [
  {
    key: 'index',
    columnProps: {type: 'index', prop: 'order', label: '序号', width: '50', align: 'center'}
  },
  {
    key: 'clinic_id',
    hidden: true,
    columnProps: {prop: 'clinic_id', label: 'clinic_id', align: 'center'}
  },
  {
    key: 'clinic_name',
    columnProps: {prop: 'clinic_name', label: '诊所名称', align: 'left', showOverflowTooltip: true}
  },
  {
    key: 'clinic_adress',
    columnProps: {prop: 'clinic_adress', label: '诊所地址', align: 'left', showOverflowTooltip: true}
  },
  {key: 'new_shengqu_name', columnProps: {prop: 'new_shengqu_name', label: '省区', align: 'left'}},
  {key: 'new_diban_name', columnProps: {prop: 'new_diban_name', label: '地办', align: 'left'}},
  {key: 'clinic_phone', columnProps: {prop: 'clinic_phone', label: '诊所电话', align: 'left'}},
  {
    key: 'action',
    isAction: true,
    label: '操作',
    width: '160',
    actionLabel: '详情'
  }
];
// 分页配置
const PAGINATION_CONFIG = {
  pageSize: 100,
  pageSizes: [100, 200, 300, 400]
};
const TABLE_HEADER_STYLE = {background: '#363944', color: 'white', border: 'none'};

export default {
  name: "ClinicList",
  data() {
    return {
      searchForm: {
        keyword: '',
        page_num: 1,
        shengqu: "",
        diban: "",
        table_name: "",
        page_size: 100,
      },
      // 下拉选项默认空数组，避免渲染期报错
      options_shengqu: [],
      options_diban: [],
      resultTbl: [],
      result_columns: [],
      hit_info: "",
      total_record: null,
      // 表头样式统一配置
      tableHeaderStyle: TABLE_HEADER_STYLE,
      // 分页配置集中管理
      paginationConfig: PAGINATION_CONFIG
    }
  },
  mounted() {
    this.get_shengqu();
    this.get_diban_zssy();
    this.onSubmit1();
  },
  computed: {
    isDemo: function () {
      return this.$store.getters.user_role === Role.Demo
    },
    // 下拉配置与数据联动
    formSelects() {
      return FORM_SELECT_CONFIGS.map((config) => ({
        ...config,
        options: this[config.optionsKey] || []
      }));
    },
    // 表格列配置集中管理，处理条件列
    tableColumns() {
      const showAction = this.searchForm.table_name !== 'western_medicine_public';
      return TABLE_COLUMNS.filter((column) => {
        if (column.hidden) {
          return false;
        }
        if (column.isAction) {
          return showAction;
        }
        return true;
      });
    }
  },
  methods: {
    // 根据配置触发表单联动逻辑
    handleSelectChange(select) {
      if (select.onChange && typeof this[select.onChange] === 'function') {
        this[select.onChange]();
      }
    },
    get_shengqu() {
      this.$http.get(API_HOST + "/get_shengqu").then((res) => {
        this.options_shengqu = res.data.data
      })
    },
    get_diban_zssy() {
      this.searchForm.diban = ''
      this.$http.get(API_HOST + "/get_diban?province_id=" + this.searchForm.shengqu).then((res) => {
        this.options_diban = res.data.data
      })
    },
    do_mixup(row) {
      this.$http.post(API_HOST + "/do_mixup", row, JSON_HEADERS).then((res) => {
        const result = res.data.data;
        for (let key in result) {
          row[key] = result[key]
        }
      })
    },
    do_fillup(row) {
      this.$http.post(API_HOST + "/do_fillup", row, JSON_HEADERS).then((res) => {
        row['patient_address'] = res.data.data
      })
    },
    do_trace(row) {
      this.$http.post(API_HOST + "/do_trace", row, JSON_HEADERS).then((res) => {
        const result = res.data.data;
        let msg = ''
        for (let key in result) {
          row[key] = result[key]
          msg += "<font color='red'><strong>" + key + "</strong></font>：" + result[key] + "<br>"
        }

        this.$alert(msg, '溯源结果', {
          dangerouslyUseHTMLString: true
        });
      })
    },
    open_detail(row) {
      // this.$router.push({path: '/clinic/clinic_info', query: {"clinic_id": row.clinic_id, "doctor_id": '-1'}});
      window.open(
        buildAppWebUrl(`/clinic/clinic_info?clinic_id=${row.clinic_id}&doctor_id=-1`),
        '_blank',
        'noopener,noreferrer'
      );
    },
    handleChangeDbSel(val) {
      this.searchForm.db_name = val.key;
      this.onSubmit1();
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.searchForm.page_size = val;

      this.onSubmit1();
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.searchForm.page_num = val;
      this.onSubmit1();
    },
    onSubmit() {
      this.onSubmit1();
    },
    onSubmit1() {
      this.$http.post(API_HOST + "/clinic/clinic_list",
          this.searchForm, JSON_HEADERS).then((res) => {
        this.resultTbl = res.data.search_result;
        this.total_record = res.data.total_record;
      })
    },

    // 表格斑马纹样式
    tableRowClassName({rowIndex}) {
      return rowIndex % 2 === 1 ? 'warning-row1' : 'success-row1';
    },
  }
}


</script>

<style scoped>
.el-form {
  margin-top: 10px;
  /* text-align: center; */
}

.el-form-item {
  text-align: center;
}

.card-header {
  border: none;
}

.select-compact {
  width: 100px;
}

.select-offset {
  margin-left: 20px;
}

.search-input {
  width: 250px;
  margin-left: 20px;
  background-color: #4B4F56;
  color: white;
}

.primary-search-btn {
  background-color: #2ECD81;
  border-color: #2ECD81;
  color: white;
}

.action-text-btn {
  color: #5CEAA8;
}

.pagination-block {
  padding-top: 10px;
}

.el-tag {

  margin-left: 10px;
  margin-top: 10px;
  cursor: pointer;
}

:deep(.el-table tbody tr:hover) {
  color: black !important
}

:deep(.el-table .warning-row1) {
  background: #363944;
}

:deep(.el-table .warning-row1 > td) {
  border: none;
}

:deep(.el-table .success-row1) {
  background: #3C3F4A;
}

:deep(.el-table .success-row1 > td) {
  border: none;
}

:deep(.el-card .el-card__header) {
  border-bottom: none;
  
  padding: 10px 20px;
}

:deep(.el-card .el-card__body) {
  background-color: #363944;
}
</style>
